import dayjs from "dayjs"
import utc from "dayjs/plugin/utc"
import customParseFormat from "dayjs/plugin/customParseFormat"
import duration from "dayjs/plugin/duration"
import minMax from "dayjs/plugin/minMax"
import isSameOrAfter from "dayjs/plugin/isSameOrAfter"
import isSameOrBefore from "dayjs/plugin/isSameOrBefore"
import weekOfYear from "dayjs/plugin/weekOfYear"
import advancedFormat from "dayjs/plugin/advancedFormat"
import localeData from "dayjs/plugin/localeData"
import updateLocale from "dayjs/plugin/updateLocale"
import localizedFormat from "dayjs/plugin/localizedFormat"
import weekday from "dayjs/plugin/weekday"
import quarterOfYear from "dayjs/plugin/quarterOfYear"
import isoWeek from "dayjs/plugin/isoWeek"
import objectSupport from "dayjs/plugin/objectSupport"

// Central configured dayjs instance — replaces moment across the app.
// Plugins cover the moment API surface in use: utc (moment.utc/.utc()/.local()),
// customParseFormat (moment(str, fmt)), duration, minMax (moment.min/max),
// isSameOrAfter/Before, weekOfYear + advancedFormat (.week()/format "w"/"X"),
// localeData (monthsShort, month/weekday names), updateLocale + weekday
// (Monday-first week config), localizedFormat (L/LL tokens).
dayjs.extend(utc)
dayjs.extend(customParseFormat)
dayjs.extend(duration)
dayjs.extend(minMax)
dayjs.extend(isSameOrAfter)
dayjs.extend(isSameOrBefore)
dayjs.extend(weekOfYear)
dayjs.extend(advancedFormat)
dayjs.extend(localeData)
dayjs.extend(updateLocale)
dayjs.extend(localizedFormat)
dayjs.extend(weekday)
dayjs.extend(quarterOfYear)
dayjs.extend(isoWeek)
dayjs.extend(objectSupport)

export type { Dayjs } from "dayjs"
export default dayjs
